import { useNavigate } from 'react-router-dom';
import '../../css/home/Tiles.css';
import { Icon } from '../../utils/icons';
import { useLang } from '../../i18n';

function Puck({ size, color }) {
  return (
    <svg width={size} height={size * 0.71} viewBox="0 0 12 8.571">
      <path
        fill={color}
        d="M 12 4.286 L 12 5.357 C 12 7.132 9.314 8.571 6 8.571 C 2.745 8.571 0.096 7.183 0.003 5.452 L 0 5.357 L 0 4.286 C 0 6.061 2.686 7.5 6 7.5 C 9.314 7.5 12 6.061 12 4.286 Z M 6 0 C 9.314 0 12 1.439 12 3.214 C 12 4.99 9.314 6.429 6 6.429 C 2.686 6.429 0 4.989 0 3.214 C 0 1.439 2.686 0 6 0 Z"
      />
    </svg>
  );
}

function SportArt({ icon, color, wm, ic }) {
  if (icon === 'puck') {
    return (
      <>
        <span className="st-wm" style={{ opacity: 0.16 }}><Puck size={wm} color="#fff" /></span>
        {ic ? <span className="st-ic"><Puck size={ic} color={color} /></span> : null}
      </>
    );
  }
  return (
    <>
      <Icon className="st-wm" name={icon} w={wm} h={wm} color="rgba(255,255,255,.16)" />
      {ic ? <Icon className="st-ic" name={icon} w={ic} h={ic} color={color} /> : null}
    </>
  );
}

const BIG_SPORTS = [
  { id: 'football',   labelKey: 'home.sports.football',   icon: 'sport-football',   color: '#36e06f', path: '/football' },
  { id: 'basketball', labelKey: 'home.sports.basketball', icon: 'sport-basketball', color: '#ffb24d', path: '/basketball' },
];

const SMALL_SPORTS = [
  { id: 'tennis',       labelKey: 'home.sports.tennis',      icon: 'sport-tennis',      color: '#ecf24f', path: '/tennis' },
  { id: 'ice-hockey',   labelKey: 'home.sports.iceHockey',   icon: 'puck',              color: '#74c6f2', path: '/ice-hockey' },
  { id: 'table-tennis', labelKey: 'home.sports.tableTennis', icon: 'sport-tabletennis', color: '#4fe6b4', path: '/table-tennis' },
];

export function BigTiles() {
  const navigate = useNavigate();
  const { t } = useLang();
  return (
    <div className="bigtiles">
      {BIG_SPORTS.map((s) => (
        <button key={s.id} className={'sporttile big tile-' + s.id} onClick={() => navigate(s.path)}>
          <SportArt icon={s.icon} color={s.color} wm={104} />
          <span className="st-label">{t(s.labelKey)}</span>
          <span className="st-cta">
            {t('home.betNow')}
            <svg width="6" height="9" viewBox="0 0 6 9">
              <path d="M1 1l3.5 3.5L1 8" stroke="rgba(255,255,255,.85)" strokeWidth="1.3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        </button>
      ))}
    </div>
  );
}

export function SmallTiles() {
  const navigate = useNavigate();
  const { t } = useLang();
  return (
    <div className="smalltiles">
      {SMALL_SPORTS.map((s) => (
        <button key={s.id} className={'sporttile small tile-' + s.id} onClick={() => navigate(s.path)}>
          <SportArt icon={s.icon} color={s.color} wm={64} ic={30} />
          <span className="st-label">{t(s.labelKey)}</span>
        </button>
      ))}
    </div>
  );
}
